/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateForeignAidRequest
 */
export interface CreateForeignAidRequest {
    /**
     * Autonomic Identifier
     * @type {string}
     * @memberof CreateForeignAidRequest
     */
    aid: string;
    /**
     * Human-readable Identifier for AID
     * @type {string}
     * @memberof CreateForeignAidRequest
     */
    alias?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateForeignAidRequest
     */
    oobi: Array<string>;
    /**
     * Best guess OR proved name of AID owner
     * @type {string}
     * @memberof CreateForeignAidRequest
     */
    who?: string;
    /**
     * Best guess OR proved delegated role associated with AID
     * @type {string}
     * @memberof CreateForeignAidRequest
     */
    role?: string;
    /**
     * Best guess OR proved org.id of org granting role
     * @type {string}
     * @memberof CreateForeignAidRequest
     */
    org?: string;
    /**
     * Bitmask that, when non-zero, converts who, role, and org from guesses to proved. bit 1 = verified by challenge response; bit 2 = by assertion from Origin; bit 3 = by introduction from trusted 3rd party; bit 4 = proved by credential
     * @type {number}
     * @memberof CreateForeignAidRequest
     */
    verified?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateForeignAidRequest
     */
    multisig?: boolean;
}

/**
 * Check if a given object implements the CreateForeignAidRequest interface.
 */
export function instanceOfCreateForeignAidRequest(value: object): boolean {
    if (!('aid' in value)) return false;
    if (!('oobi' in value)) return false;
    return true;
}

export function CreateForeignAidRequestFromJSON(json: any): CreateForeignAidRequest {
    return CreateForeignAidRequestFromJSONTyped(json, false);
}

export function CreateForeignAidRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateForeignAidRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'aid': json['aid'],
        'alias': json['alias'] == null ? undefined : json['alias'],
        'oobi': json['oobi'],
        'who': json['who'] == null ? undefined : json['who'],
        'role': json['role'] == null ? undefined : json['role'],
        'org': json['org'] == null ? undefined : json['org'],
        'verified': json['verified'] == null ? undefined : json['verified'],
        'multisig': json['multisig'] == null ? undefined : json['multisig'],
    };
}

export function CreateForeignAidRequestToJSON(value?: CreateForeignAidRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'aid': value['aid'],
        'alias': value['alias'],
        'oobi': value['oobi'],
        'who': value['who'],
        'role': value['role'],
        'org': value['org'],
        'verified': value['verified'],
        'multisig': value['multisig'],
    };
}

